var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntaglioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient1323",
    cx: 14.608,
    cy: 12.546,
    r: 0.5,
    gradientTransform: "matrix(1 0 0 13.091 0 -151.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.89812 0 0 -.89812 1.8847 30.305)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-10h10v-10h22v20z",
    fill: "#008768"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 6h6.7176v7.0674h-6.7176z",
    fill: "#008768",
    strokeWidth: 0.86128
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.608 6v13.091",
    fill: "url(#radialGradient1323)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.8906
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntaglioIcon);
export default __webpack_public_path__ + "static/media/IntaglioIcon.df949e4a5b4f560c8c43366bb190fdaf.svg";
export { ForwardRef as ReactComponent };